<template>
  <div>
    <b-row>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-truck bg-primary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 pt-3" v-if="ready && data && !loading">{{ totaKgs }} ton</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Total Recibido</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-arrow-up bg-secondary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-black mb-0 pt-3" v-if="ready && data && !loading">{{ dailyAvg }} ton / día</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Promedio diario</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-calendar bg-secondary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-dark mb-0 pt-3" v-if="ready && data && !loading">{{ kgsToday }} ton</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Recibido {{ to_date }}</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="3">
        <b-card :no-body="true">
          <b-card-body class="p-0 clearfix">
            <i class="fa fa-bell bg-secondary p-4 px-5 font-2xl mr-3 float-left"></i>
            <div class="h5 text-dark mb-0 pt-3" v-if="ready && data && !loading">{{ maxReceived }} ton</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">Máximo del periodo</div>
            <b-spinner v-if="loading"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col> </b-row
    ><!--/.row-->
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      data: null,
      ready: false,
      loading: true
    };
  },
  computed: {
    maxReceived() {
      const value = Math.max(...Object.values(this.data).map((c) => parseFloat(c))) / 1000;
      return new Intl.NumberFormat("es-CL").format(value.toFixed(2));
    },
    totaKgs() {
      const val = Object.values(this.data).reduce((val, acc) => parseFloat(acc) + parseFloat(val), 0) / 1000;
      return new Intl.NumberFormat("es-CL").format(val.toFixed(2));
    },
    kgsToday() {
      const date = moment(this.to_date).format("YYYY-MM-DD");
      const val = parseFloat(this.data[date]) / 1000;
      return new Intl.NumberFormat("es-CL").format(val.toFixed(2)) || 0;
    },
    dailyAvg() {
      console.log(parseFloat(this.totaKgs), Object.keys(this.data).length);
      const val =
        Object.values(this.data).reduce((val, acc) => parseFloat(acc) + parseFloat(val), 0) /
        Object.keys(this.data).length;
      return new Intl.NumberFormat("es-CL").format((val / 1000).toFixed(2));
    }
  },
  props: ["client_customer", "from_date", "to_date", "product"],
  async mounted() {
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/arrivals/total_day?client_customer=${this.client_customer}&product=${this.product}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.data = {};
      response.data.labels.forEach((l, i) => (this.data[l] = response.data.dataset[i]));
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    this.$nextTick(() => {
      this.ready = true;
    });
  }
};
</script>

<style></style>
